// extracted by mini-css-extract-plugin
module.exports = {"metadata":"Metadata_metadata__7tpq9","formGroup":"Metadata_formGroup__7fvTn","privacyWrapper":"Metadata_privacyWrapper__2q-aX"};